export const HASH_BYTES_LENGTH = 32;
